import cn from 'classnames';
import { useState } from 'react';

import { FavoritesSection } from '../FavoritesSection';
import { NavFavorite } from '../NavSection';

import s from './FavoritesPanel.module.scss';

type Props = {
  queues: NavFavorite[];
  boards: NavFavorite[];
};

/**
 * Избранное у правого края, как панель избранных задач таймлога: виден язычок, при наведении
 * выезжает список. Открывается на CSS (:hover и :focus-within) — с клавиатуры фокусом на ссылке
 */
const FavoritesPanel: React.FC<Props> = ({ queues, boards }) => {
  // После перехода курсор ещё над панелью — держим её закрытой, пока он не уйдёт
  const [isDismissed, setIsDismissed] = useState(false);

  const handleNavigate = (event: React.MouseEvent<HTMLAnchorElement>) => {
    setIsDismissed(true);
    // Иначе панель держал бы открытой фокус на ссылке
    event.currentTarget.blur();
  };

  return (
    <nav
      className={cn(s.panel, isDismissed && s.panel_dismissed)}
      aria-label="Избранное"
      onMouseLeave={() => setIsDismissed(false)}
    >
      <div className={s.panel__tab} aria-hidden>
        <span className={s.panel__tabText}>Избранное</span>
      </div>
      <div className={s.panel__body}>
        <h3 className={s.panel__title}>Избранное</h3>
        <FavoritesSection
          title="Очереди"
          links={queues}
          emptyText="Отметьте очередь звёздочкой в её шапке"
          onNavigate={handleNavigate}
        />
        <FavoritesSection
          title="Доски"
          links={boards}
          emptyText="Отметьте доску звёздочкой в её шапке"
          onNavigate={handleNavigate}
        />
      </div>
    </nav>
  );
};

export { FavoritesPanel };
